import { createActions } from "reduxsauce";

export default createActions(
  {
    localeChanged: ["localeCode"]
  },
  { prefix: "locale/" }
);



// WEBPACK FOOTER //
// ./src/modules/i18n/locale-actions.js